import { render, staticRenderFns } from "./Pacientes.vue?vue&type=template&id=5bd18992&lang=pug&"
import script from "./Pacientes.vue?vue&type=script&lang=js&"
export * from "./Pacientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports